// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1___f5bf5a466aad7e38ab2","cls2":"SuggestedUserCard-cls2___a636974c3bce421aa7d SuggestedUserCard-cls1___f5bf5a466aad7e38ab2"};